define(['jquery'],
    function($) {

        return {'init': function() {
            $('.print_js').on('click', function () {
                let restorepage = $('body').html();
                let printcontent = $('.card').clone();
                $('body').empty().html(printcontent);
                window.print();
                $('body').html(restorepage);
                $('#saved').removeClass('disabled');
            });

            $('.copy_js').on('click', function () {
                let $temp = $("<textarea>");
                $("body").append($temp);
                $temp.val($('.codes').text()).select();
                document.execCommand("copy");
                $temp.remove();
                $('#saved').removeClass('disabled');
            });
        }};
    }
);
